module.exports = __webpack_public_path__ + "img/vuetify.ed09cdb0.svg";